import MultiBrand from '@images/svg/multiBrand.svg';
import { FamilyLogos } from '@sainsburys-tech/fable';
import * as React from 'react';
export default {
  MultiBrand,
  FamilyLogos,
  React
};